import React from 'react'
import { useRouter } from 'next/router'

import {
  HeaderBar,
  HeaderBarTitle,
  HeaderBarLeftAction,
} from '@wartek-id/header-bar'

import Quiz from 'app/PelatihanMandiriPage/pages/Quiz'
import PelatihanDetailShell from 'app/PelatihanMandiriPage/components/PelatihanDetailShell'
import { usePelatihanMandiriDesktopDetailView } from 'app/PelatihanMandiriPage/hooks/usePelatihanMandiriDesktopDetailView'
import { getModuleReturnUrl } from 'app/PelatihanMandiriPage/utils/detailNavigation'

import CloseIcon from 'assets/icons/close.svg'

const QuizPage = () => {
  const isDesktopDetail = usePelatihanMandiriDesktopDetailView()
  const { query } = useRouter()

  if (isDesktopDetail) {
    return (
      <PelatihanDetailShell
        breadcrumbs={[
          { label: 'Pelatihan Mandiri', href: '/pelatihan-mandiri' },
          {
            label: String(query.topik_name ?? 'Topik'),
            href: `/pelatihan-mandiri/topik/${query.topik}`,
          },
          {
            label: String(query.modul_name ?? 'Modul'),
            href: getModuleReturnUrl(query, query.id as string),
          },
          { label: 'Latihan Pemahaman', href: null },
        ]}
        contentClassName="rounded-lg border border-gray-20 bg-white p-6"
      >
        <Quiz isDesktop />
      </PelatihanDetailShell>
    )
  }

  return <Quiz />
}

const PageHeader = () => {
  const { query, replace } = useRouter()
  const backUrl = getModuleReturnUrl(query, query.id as string)

  return (
    <HeaderBar fixed className="z-10">
      <HeaderBarLeftAction
        data-testid="back-button"
        icon={<CloseIcon className="stroke-current text-default" />}
        onClick={() => replace(backUrl)}
      />
      <HeaderBarTitle>Latihan Pemahaman</HeaderBarTitle>
    </HeaderBar>
  )
}

QuizPage.layoutOpts = {
  hasHeader: true,
  className: 'text-default',
  header: PageHeader,

  enableDesktopLayout: true,
}

export default QuizPage
